var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.handleTimePicker}},[_c('v-text-field',_vm._b({attrs:{"append-icon":"mdi-clock","readonly":"","value":_vm.value},on:{"click:clear":function($event){return _vm.$emit('change', '')}}},'v-text-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }